import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-export",
  "use": "icon-export-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-export\">\n  <path d=\"M2.6665 8.66699V12.667C2.6665 13.4034 3.26346 14.0003 3.99984 14.0003H11.9998C12.7362 14.0003 13.3332 13.4034 13.3332 12.667V8.66699\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n  <path d=\"M8.00008 10V2M8.00008 2L5.66675 4.33333M8.00008 2L10.3334 4.33333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol